import * as UI     from '../../ui';
import { connect } from 'react-redux';

// connctProgress
// redux helper to pass progress actions to a component

export default connect(
  null,
  dispatch => ({
    progressStart: () => dispatch(UI.progressStart()),
    progressEnd:   () => dispatch(UI.progressEnd())
  })
);
